var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_38482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_38482)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#6BDEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4229 48.4057L22.3763 48.4657C22.1053 48.7775 21.7743 49.0314 21.4029 49.2124C21.0872 49.3575 20.7438 49.4326 20.3963 49.4324C20.2238 49.4313 20.0519 49.4134 19.8829 49.3791L21.0629 47.3324C21.4551 46.7847 21.7187 46.1556 21.8342 45.4919C21.9496 44.8282 21.9138 44.147 21.7296 43.4991C21.4363 42.6591 20.9096 42.5591 20.7296 42.5257H20.6629C17.3992 41.6308 14.3901 39.9847 11.8763 37.7191C11.4829 37.3657 11.1029 37.0057 10.7363 36.6257C10.3696 36.2457 9.95628 35.7391 9.58294 35.2924C8.73775 34.2788 7.9774 33.1974 7.30961 32.0591C5.38151 28.7703 4.22575 25.0865 3.92961 21.2857L3.84961 20.3391L4.31628 20.0391L14.1829 20.3391L14.1429 21.2524C14.1429 21.2524 14.0629 23.7457 15.4763 25.2524C15.8024 25.6043 16.1972 25.8856 16.6363 26.0791C17.2446 26.3427 17.8999 26.481 18.5629 26.4857L19.0296 28.3924C18.2293 28.3432 17.4362 28.2114 16.6629 27.9991C15.7278 27.7237 14.8831 27.2035 14.2163 26.4924C13.1639 25.2659 12.5371 23.7316 12.4296 22.1191H5.76294C6.01325 24.1782 6.53327 26.1955 7.30961 28.1191C7.91408 29.6178 8.67614 31.0481 9.58294 32.3857C9.94961 32.9324 10.3429 33.4524 10.7496 33.9524C11.1563 34.4524 11.4896 34.8324 11.8896 35.2457C14.3985 37.8942 17.5812 39.8094 21.0963 40.7857C21.2436 40.8147 21.3884 40.8548 21.5296 40.9057C21.9743 41.0719 22.3744 41.339 22.6983 41.686C23.0222 42.0331 23.2612 42.4506 23.3963 42.9057C23.6751 43.8348 23.7323 44.8163 23.5633 45.7714C23.3942 46.7266 23.0037 47.6288 22.4229 48.4057Z",
    fill: "url(#paint0_linear_845_38482)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1834 21.5205L12.4301 22.0939H5.92339L5.63672 21.0605L13.1834 21.5205Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4228 48.4062L22.3761 48.4663C22.1052 48.778 21.7741 49.032 21.4028 49.2129C21.0871 49.3581 20.7436 49.4331 20.3961 49.4329C20.2237 49.4318 20.0518 49.4139 19.8828 49.3796L20.3495 49.0796L22.4228 48.4062Z",
    fill: "#777777"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8364 48.1657C22.5618 48.4775 22.2259 48.7294 21.8497 48.9057C21.5345 49.053 21.191 49.1303 20.8431 49.1324C20.6706 49.1313 20.4987 49.1134 20.3297 49.0791L21.5097 47.0057C21.9019 46.458 22.1655 45.8289 22.2809 45.1652C22.3964 44.5015 22.3606 43.8204 22.1764 43.1724C21.9164 42.3324 21.3897 42.2324 21.1831 42.1991H21.1164C17.8527 41.3041 14.8436 39.6581 12.3297 37.3924C11.9364 37.0391 11.5564 36.6724 11.1897 36.2991C10.8231 35.9257 10.4231 35.4391 10.0497 34.9924C9.20454 33.9788 8.4442 32.8974 7.77641 31.7591C5.84916 28.4695 4.69136 24.7864 4.38974 20.9857L4.31641 20.0391H14.6497L14.6097 20.9524C14.6097 20.9524 14.5297 23.4457 15.9431 24.9524C16.2668 25.3041 16.6594 25.5855 17.0964 25.7791C17.7071 26.0427 18.3646 26.181 19.0297 26.1857L18.9897 27.9324C18.3491 27.9222 17.7126 27.828 17.0964 27.6524C16.1624 27.3753 15.3197 26.8527 14.6564 26.1391C13.6028 24.9133 12.9758 23.3786 12.8697 21.7657H6.20307C6.44961 23.8256 6.96975 25.8434 7.74974 27.7657C8.36067 29.2834 9.1317 30.7316 10.0497 32.0857C10.4164 32.6257 10.8097 33.1524 11.2164 33.6524C11.6231 34.1524 11.9564 34.5324 12.3564 34.9391C14.8649 37.5894 18.0476 39.5069 21.5631 40.4857C21.7089 40.5115 21.8518 40.5517 21.9897 40.6057C22.4365 40.7696 22.8386 41.0359 23.164 41.3832C23.4893 41.7305 23.7287 42.1492 23.8631 42.6057C24.1455 43.5474 24.1998 44.5429 24.0212 45.5097C23.8427 46.4766 23.4366 47.387 22.8364 48.1657Z",
    fill: "url(#paint1_linear_845_38482)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8363 48.1674C22.5617 48.4792 22.2258 48.7311 21.8496 48.9074C23.6496 45.6808 22.6696 42.2408 21.9696 40.6074C22.4164 40.7713 22.8185 41.0376 23.1438 41.3849C23.4691 41.7322 23.7086 42.1509 23.8429 42.6074C24.1282 43.5476 24.1857 44.5421 24.0106 45.5089C23.8356 46.4757 23.4331 47.3869 22.8363 48.1674Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.123 25.8008C17.7338 26.0644 18.3912 26.2027 19.0564 26.2074L19.0164 27.9541C18.3757 27.9439 17.7392 27.8498 17.123 27.6741V25.8008Z",
    fill: "#777777"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9768 20.3409L60.8968 21.2876C60.6309 24.6981 59.6737 28.0188 58.0835 31.0476C57.7702 31.6409 57.4168 32.2076 57.0902 32.7676C56.7635 33.3276 56.3702 33.8476 55.9835 34.3676C55.354 35.1965 54.6726 35.9847 53.9435 36.7276C51.2464 39.4804 47.8669 41.4681 44.1502 42.4876H44.0835C43.9035 42.4876 43.3768 42.6209 43.0835 43.4609C42.7762 44.5741 42.8926 45.7618 43.4102 46.7942C43.5099 46.9791 43.6283 47.1534 43.7635 47.3142L45.6368 49.0876L44.9702 49.3876C44.8012 49.4219 44.6293 49.4397 44.4568 49.4409C44.1904 49.4517 43.9241 49.4156 43.6702 49.3342C43.4178 49.2446 43.1797 49.1189 42.9635 48.9609C42.7781 48.8218 42.6063 48.6655 42.4502 48.4942C41.853 47.7126 41.4493 46.8008 41.272 45.8333C41.0947 44.8658 41.1489 43.8701 41.4302 42.9276C41.571 42.449 41.8269 42.0122 42.1756 41.6554C42.5242 41.2986 42.955 41.0327 43.4302 40.8809L43.7035 40.8142C47.7123 39.6946 51.2786 37.3667 53.9168 34.1476C54.6702 33.2347 55.3522 32.2651 55.9568 31.2476C56.3612 30.5646 56.7306 29.8614 57.0635 29.1409C57.4399 28.3081 57.7715 27.4558 58.0568 26.5876C58.5243 25.1308 58.8525 23.633 59.0368 22.1142H52.3702C52.2627 23.7267 51.6359 25.2611 50.5835 26.4876C49.915 27.2047 49.065 27.7276 48.1235 28.0009C47.5229 28.174 46.9018 28.2659 46.2768 28.2742L46.2368 26.5276C46.8848 26.5221 47.5256 26.3908 48.1235 26.1409C48.5816 25.945 48.9929 25.6542 49.3302 25.2876C50.7502 23.7742 50.6635 21.2876 50.6635 21.2876L50.6235 20.3742L51.2902 20.0742L60.9768 20.3409Z",
    fill: "url(#paint2_linear_845_38482)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8834 21.6939L59.0634 22.0939H52.4434V21.2539L59.8834 21.6939Z",
    fill: "#777777"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6684 20.0391L61.5884 20.9857C61.3192 24.3965 60.3598 27.717 58.7684 30.7457C58.4617 31.3391 58.1017 31.9057 57.775 32.4657C57.4484 33.0257 57.055 33.5457 56.6684 34.0657C56.0408 34.8962 55.3593 35.6846 54.6284 36.4257C51.9337 39.1784 48.5564 41.1661 44.8417 42.1857H44.7684C44.595 42.2191 44.0684 42.3191 43.775 43.1591C43.4677 44.2723 43.5841 45.46 44.1017 46.4924C44.1951 46.6831 44.314 46.8603 44.455 47.0191L45.635 49.0924C45.466 49.1263 45.2941 49.1441 45.1217 49.1457C44.8608 49.147 44.6016 49.1042 44.355 49.0191C44.1017 48.9288 43.8634 48.8006 43.6484 48.6391C43.4623 48.5058 43.2922 48.3515 43.1417 48.1791C42.5431 47.3982 42.1385 46.4864 41.9611 45.5186C41.7838 44.5508 41.8388 43.5548 42.1217 42.6124C42.2604 42.1328 42.5156 41.6949 42.8645 41.3378C43.2135 40.9807 43.6454 40.7154 44.1217 40.5657C44.2087 40.5365 44.2979 40.5142 44.3884 40.4991C48.3975 39.3803 51.964 37.0522 54.6017 33.8324C55.3572 32.9235 56.0394 31.956 56.6417 30.9391C57.0474 30.2545 57.4168 29.5491 57.7484 28.8257C58.1316 27.9981 58.4633 27.1476 58.7417 26.2791C59.213 24.8211 59.5412 23.3207 59.7217 21.7991H53.055C52.9457 23.4111 52.3191 24.9449 51.2684 26.1724C50.5911 26.8966 49.729 27.4221 48.775 27.6924C48.1766 27.865 47.5578 27.9569 46.935 27.9657L46.895 26.2191C47.5408 26.213 48.1793 26.0816 48.775 25.8324C49.2351 25.6367 49.6486 25.3459 49.9884 24.9791C51.4084 23.4657 51.3217 20.9791 51.3217 20.9791L51.2817 20.0657L61.6684 20.0391Z",
    fill: "url(#paint3_linear_845_38482)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6484 48.6261C43.4623 48.4928 43.2922 48.3385 43.1417 48.1661C42.5431 47.3852 42.1385 46.4734 41.9611 45.5056C41.7838 44.5378 41.8388 43.5418 42.1217 42.5994C42.2604 42.1198 42.5156 41.6819 42.8645 41.3248C43.2135 40.9677 43.6454 40.7024 44.1217 40.5527C43.3817 41.9994 42.1017 45.2794 43.6484 48.6261Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8097 25.8203V27.6803C48.2112 27.8529 47.5924 27.9448 46.9697 27.9536L46.9297 26.207C47.5755 26.2009 48.2139 26.0696 48.8097 25.8203Z",
    fill: "#777777"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7685 18.873C47.7685 19.6197 47.7685 20.3997 47.7152 21.213C47.7152 21.553 47.7152 21.8797 47.6685 22.2597C47.361 27.8367 46.3371 33.3509 44.6218 38.6664C42.2752 45.473 38.5152 50.913 32.8885 50.913C22.8218 50.913 18.6752 33.4664 18.0818 21.7397C18.0818 21.5664 18.0818 21.3864 18.0818 21.213C18.0818 20.3997 18.0352 19.6197 18.0352 18.873H47.7685Z",
    fill: "url(#paint4_linear_845_38482)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4428 34.6663C37.4381 35.2832 37.4025 35.8995 37.3361 36.5129C37.2894 36.5129 37.0694 36.9129 36.9828 36.9529H31.9161H29.9161C29.7628 36.5329 29.6094 36.0396 29.4961 35.6196C29.4961 35.5729 29.8694 35.2263 29.8561 35.1796C30.6732 34.6154 31.4526 33.9985 32.1894 33.3329C32.6598 32.9294 33.1051 32.4975 33.5228 32.0396C33.9692 31.4936 34.2265 30.8176 34.2561 30.1129C34.2748 29.6859 34.1478 29.2651 33.8961 28.9196C33.782 28.7793 33.6374 28.6668 33.4734 28.5906C33.3094 28.5144 33.1302 28.4764 32.9494 28.4796C32.6786 28.477 32.4097 28.5245 32.1561 28.6196L31.8494 29.9996C31.8028 29.9996 31.5361 30.4396 31.4894 30.4396C30.9494 30.4396 30.4028 30.2996 29.9094 30.2729C29.9561 29.3396 30.0161 28.4063 30.0761 27.4929C30.0761 27.4329 30.4361 27.1063 30.4361 27.0463C31.4062 26.6941 32.4307 26.5158 33.4628 26.5196C34.8961 26.5196 35.7494 26.7996 36.3894 27.3596C36.6936 27.6265 36.9368 27.9558 37.1025 28.3251C37.2681 28.6943 37.3523 29.0949 37.3494 29.4996C37.2955 30.5258 36.866 31.4963 36.1428 32.2263C35.5059 33.0293 34.7611 33.7405 33.9294 34.3396C33.7028 34.5263 33.5094 34.6729 33.3161 34.8063C34.4494 34.8063 36.5361 34.6863 37.4428 34.6729V34.6663Z",
    fill: "#8B8B8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4086 34.6675C36.502 34.6675 34.4153 34.7809 33.282 34.8009H33.0886V34.7409C33.4953 34.4609 33.822 34.2409 34.2553 33.8875C34.9253 33.3905 35.5459 32.8301 36.1086 32.2142C36.8318 31.4842 37.2613 30.5137 37.3153 29.4875C37.3185 29.0796 37.2331 28.6758 37.0651 28.304C36.897 27.9322 36.6503 27.6014 36.342 27.3342C35.6753 26.7742 34.8486 26.4942 33.4153 26.4942C32.3833 26.4904 31.3587 26.6687 30.3886 27.0209C30.3886 27.0809 30.0353 27.4075 30.0286 27.4675C29.9753 28.3209 30.262 28.9342 30.222 29.8009C30.5286 29.8009 30.762 30.0875 31.0353 30.2675C31.1547 30.3531 31.2954 30.4039 31.442 30.4142C31.4886 30.4142 31.7553 29.9742 31.802 29.9742L32.122 28.5809L32.1553 28.4209V28.3542C32.1639 28.3189 32.1852 28.288 32.2153 28.2675C32.5285 28.0791 32.89 27.9864 33.2553 28.0009C33.4354 27.9978 33.614 28.0352 33.7778 28.1102C33.9416 28.1852 34.0865 28.2959 34.202 28.4342C34.4518 28.7803 34.5764 29.2012 34.5553 29.6275C34.5078 30.5199 34.1356 31.3641 33.5086 32.0009C33.0909 32.4587 32.6457 32.8907 32.1753 33.2942C31.4416 33.971 30.6644 34.599 29.8486 35.1742C29.8486 35.2209 29.4753 35.5675 29.4886 35.6142C29.5953 36.0142 30.1553 36.1542 30.2686 36.5275H32.2686C33.342 36.5275 36.002 36.9809 36.9753 36.9875C37.062 36.9475 37.282 36.5475 37.3286 36.5475C37.3984 35.9232 37.4362 35.2957 37.442 34.6675H37.4086Z",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1958 28.3674V28.4341L32.1625 28.5941L31.8491 30.0008C31.8025 30.0008 31.5358 30.4408 31.4891 30.4408C31.3426 30.4305 31.2018 30.3797 31.0825 30.2941C31.0741 30.172 31.0741 30.0495 31.0825 29.9274C31.1717 29.5114 31.3591 29.1229 31.6291 28.7941C31.7025 28.7074 32.0092 28.2941 32.1758 28.3608L32.1958 28.3674Z",
    fill: "#7E7E7E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.444 34.6665C37.4393 35.2834 37.4037 35.8998 37.3373 36.5132C37.2906 36.5132 37.0706 36.9132 36.984 36.9532L36.8906 36.9198L36.9906 35.1865L37.064 35.0932L37.4173 34.6465L37.444 34.6665Z",
    fill: "#7E7E7E"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.056 35.1132C36.096 35.1132 33.8093 35.2332 32.736 35.2532V35.1865C32.936 35.0532 33.1093 34.9332 33.2893 34.7998C33.4693 34.6665 33.676 34.5198 33.9026 34.3332C34.7343 33.7341 35.4791 33.0229 36.116 32.2198C36.639 31.5724 36.9363 30.7718 36.9626 29.9398C36.9652 29.5342 36.8808 29.1328 36.7152 28.7625C36.5497 28.3922 36.3067 28.0617 36.0026 27.7932C35.336 27.2332 34.5093 26.9532 33.0826 26.9532C32.0479 26.9501 31.0209 27.1307 30.0493 27.4865C29.9893 28.3998 29.9293 29.3332 29.8826 30.2665C30.376 30.2665 30.9226 30.4332 31.4626 30.4332L31.8493 28.8732C31.8591 28.8149 31.8871 28.7612 31.9293 28.7198C32.0079 28.6709 32.0904 28.6285 32.176 28.5932C32.4295 28.4981 32.6985 28.4506 32.9693 28.4532C33.1501 28.45 33.3293 28.4879 33.4933 28.5642C33.6573 28.6404 33.8018 28.7529 33.916 28.8932C34.1677 29.2387 34.2946 29.6594 34.276 30.0865C34.2341 30.7904 33.9651 31.4618 33.5093 31.9998C33.0131 32.6358 32.4572 33.2229 31.8493 33.7532C31.1153 34.4207 30.3405 35.0419 29.5293 35.6132C29.6426 36.0532 29.796 36.5465 29.9493 36.9465H31.9493H37.016C37.0824 36.3353 37.118 35.7212 37.1226 35.1065L37.056 35.1132Z",
    fill: "#63686E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6236 38.6664C42.9303 43.573 40.517 47.7797 37.1836 49.7397C35.8961 50.5095 34.4237 50.915 32.9236 50.913C22.857 50.913 18.7103 33.4664 18.117 21.7397C18.117 21.5664 18.117 21.3864 18.117 21.213C18.117 20.3997 18.0703 19.6197 18.0703 18.873H27.417L26.9703 20.5664C26.9703 20.5664 28.357 53.8264 44.6236 38.6664Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4617 49.5464C25.7617 45.253 21.695 26.7397 20.515 18.873H18.875C18.875 19.6197 18.875 20.3997 18.9283 21.213C18.9283 21.3864 18.9283 21.5664 18.9283 21.7464C19.515 33.293 23.5483 50.413 33.295 50.8997L37.4617 49.5464Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7698 18.873C47.7698 19.6197 47.7698 20.3997 47.7164 21.213C47.7164 21.553 47.7164 21.8797 47.6698 22.2597C41.088 21.539 34.4708 21.1895 27.8498 21.213C21.6631 21.213 19.0831 21.473 18.0564 21.7397C18.0564 21.5664 18.0564 21.3864 18.0564 21.213C18.0564 20.3997 18.0098 19.6197 18.0098 18.873H47.7698Z",
    fill: "#777777"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6292 18L49.3826 18.8267L48.9359 20.3333H16.8426L16.1426 18H49.6292Z",
    fill: "url(#paint5_linear_845_38482)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8973 51.927L37.624 52.1604C37.2429 52.4921 36.8885 52.8532 36.564 53.2404C36.3235 53.4943 36.1655 53.815 36.1106 54.1604C36.1166 55.1205 35.9864 56.0767 35.724 57.0004C35.6352 57.3168 35.5238 57.6265 35.3906 57.927L35.3373 58.0604C35.2773 58.1737 35.224 58.2937 35.164 58.4004C34.584 59.487 33.7773 60.1604 32.8906 60.1604C32.3939 60.1434 31.9201 59.9468 31.5573 59.607C31.0831 59.1771 30.7078 58.6494 30.4573 58.0604C29.9252 56.8301 29.6615 55.5006 29.684 54.1604C29.684 53.367 27.8906 51.927 27.8906 51.927V51.887L28.5573 49.707H37.184L37.5306 50.8137L37.784 51.6137L37.8706 51.887L37.8973 51.927Z",
    fill: "#878C98"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.884 51.887H27.8906L28.5773 49.707H37.1973L37.544 50.8137L37.7973 51.6137L37.884 51.887Z",
    fill: "url(#paint6_linear_845_38482)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5417 59.607C30.435 58.6604 29.6683 56.5804 29.6683 54.1604C29.6683 53.367 27.875 51.927 27.875 51.927L28.575 49.707H37.1817C37.1817 49.707 28.4417 50.1004 30.415 52.1737C30.5417 52.527 31.9483 52.6137 31.9483 52.6137C31.9483 52.6137 30.615 57.6804 32.3817 58.0604C33.235 58.2337 32.515 58.9337 31.5417 59.607Z",
    fill: "#777777"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9229 60.1605H29.8496L30.4429 58.0605H35.3363L35.4829 58.6005L35.8496 59.8805L35.9229 60.1605Z",
    fill: "url(#paint7_linear_845_38482)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3226 75.0935H28.4492L29.8492 60.1602H35.9226L35.9492 60.4468L37.3226 75.0935Z",
    fill: "#878C98"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8957 51.9258L37.6224 52.1592C35.7757 52.1592 33.1891 52.0458 32.2891 52.0325C32.7959 52.0126 33.3012 51.9637 33.8024 51.8858C35.0844 51.6558 36.3397 51.2961 37.5491 50.8125L37.8024 51.6125L37.8891 51.8858L37.8957 51.9258Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9486 60.4475L31.8086 60.1609L35.8086 59.8809L35.9019 60.1609L35.9486 60.4475Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6301 18L49.3834 18.8267L24.6367 18H49.6301Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3963 58.0605L31.8829 60.1605H29.8496L30.4429 58.0605H32.3963Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8826 60.1602L31.1425 75.0935H30.9892H28.4492L29.8492 60.1602H31.8826Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 20.3333H16.8424L16.1758 18H22.1224C21.4424 18.4267 19.5891 20.1267 30.6891 20.3333Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8492 20.3333H16.8426L16.1426 18H17.8226L18.8492 20.3333Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M28.17 36.8526C28.17 36.8526 25.0233 29.5926 25.6367 22.5859H22.75C22.75 22.5859 23.4833 32.1326 28.17 36.8526Z",
    fill: "url(#paint8_linear_845_38482)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M38.1953 40.4393C38.2104 40.3667 38.2104 40.2918 38.1953 40.2193C38.322 38.1593 38.1953 22.5859 38.1953 22.5859H46.4553C46.4553 22.5859 46.602 39.1259 38.1953 40.4393Z",
    fill: "url(#paint9_linear_845_38482)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9102 40.7009C38.0368 38.6476 37.9102 23.0742 37.9102 23.0742H41.1835C41.1835 26.7009 40.8435 36.3742 37.9102 40.7009Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1106 18H32.8906V20.3333H39.1106V18Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2564 18H40.623V20.3333H42.2564V18Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 20.0391H54.6289V21.7924H56.6689V20.0391Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 30.9258V34.0658C56.0414 34.8963 55.3599 35.6847 54.6289 36.4258V33.8191C55.3844 32.9102 56.0666 31.9427 56.6689 30.9258Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 20.0391H57.7773V21.7924H58.7707V20.0391Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 26.2676V30.7476C58.464 31.3409 58.104 31.9076 57.7773 32.4676V28.8142C58.1606 27.9866 58.4923 27.1361 58.7707 26.2676Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0573 20.0391H7.77734V21.7924H10.0573V20.0391Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0507 32.0866V34.9933C9.20548 33.9797 8.44514 32.8983 7.77734 31.76V27.8066C8.38237 29.3093 9.14438 30.744 10.0507 32.0866Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 20.0391H11.2168V21.7924H12.3568V20.0391Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 34.941V37.381C11.9635 37.0276 11.5835 36.661 11.2168 36.2876V33.6543C11.5768 34.101 11.9568 34.5343 12.3568 34.941Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6368 49.0805C45.4678 49.1144 45.2959 49.1322 45.1235 49.1338C44.8626 49.1351 44.6034 49.0923 44.3568 49.0071C44.1946 48.1745 44.1098 47.3287 44.1035 46.4805C44.1969 46.6712 44.3158 46.8484 44.4568 47.0071L45.6368 49.0805Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5561 75.0933H33.8828L34.5295 63.4199L36.5561 75.0933Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1235 75.0933H32.7168V63.4199L33.1235 75.0933Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 53.7069C34.1693 54.1336 35.8693 55.9869 34.2093 57.8802C33.9228 57.9609 33.631 58.0211 33.3359 58.0602C33.9686 58.0416 34.598 58.1575 35.1826 58.4002C35.2976 58.4525 35.4052 58.5198 35.5026 58.6002L35.3559 58.0602L35.4093 57.9269C35.4093 57.8669 35.4626 57.8002 35.4826 57.7402C35.5177 57.6664 35.5489 57.5907 35.5759 57.5136C35.6359 57.3536 35.6893 57.1802 35.7426 57.0002C36.005 56.0766 36.1352 55.1204 36.1293 54.1602C36.1841 53.8149 36.3421 53.4941 36.5826 53.2402C35.5301 53.5587 34.4355 53.716 33.3359 53.7069Z",
    fill: "#777777"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_845_38482",
    x1: 22.0629,
    y1: 33.6791,
    x2: -4.63706,
    y2: 36.6057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_845_38482",
    x1: 17.7964,
    y1: 35.5324,
    x2: 1.24974,
    y2: 10.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_845_38482",
    x1: 41.1635,
    y1: 34.7409,
    x2: 60.9768,
    y2: 34.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_845_38482",
    x1: 41.855,
    y1: 34.5857,
    x2: 61.6684,
    y2: 34.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_845_38482",
    x1: 18.0085,
    y1: 34.893,
    x2: 47.7685,
    y2: 34.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_845_38482",
    x1: 16.1426,
    y1: 19.1667,
    x2: 49.6359,
    y2: 19.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_845_38482",
    x1: 27.8906,
    y1: 50.7937,
    x2: 37.884,
    y2: 50.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_845_38482",
    x1: 30.0896,
    y1: 59.1472,
    x2: 39.0763,
    y2: 59.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E969E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_845_38482",
    x1: 22.75,
    y1: 29.7193,
    x2: 28.17,
    y2: 29.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_845_38482",
    x1: 38.1953,
    y1: 31.5126,
    x2: 46.4553,
    y2: 31.5126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara2);
export default __webpack_public_path__ + "static/media/juara-2.a88a498293ff297e4d089f9c15f9fbd5.svg";
export { ForwardRef as ReactComponent };